















































import Vue from "vue";

import AuthContainer from "@tt-app/components/user/auth/AuthContainer.vue";
import AuthInstructions from "@tt-app/components/user/auth/AuthInstructions.vue";
import IconPasswordReset from "@joyz/app-core/assets/icons/default/ResetPassword.svg";

import { api } from "@tt-app/api";
import AuthCard from "@tt-app/components/user/auth/AuthCard.vue";
import { ROUTES } from "@tt-app/constants/router";
import { TTFormInputValue, PageStatus } from "@tt-app/models";

const {
  USER: { AUTHENTICATION }
} = ROUTES;

interface State {
  email: TTFormInputValue<string>;
  pageStatus: PageStatus;
}
interface Computed {
  isFormValid: boolean;
  iconResetPassword: string;
}

interface Method {
  submitPwdRequest: () => Promise<void>;
  goToLoginPage: () => void;
}

export default Vue.extend<State, Method, Computed, {}>({
  name: "PwdChangeRequest",
  components: { AuthCard, AuthContainer, AuthInstructions },

  data() {
    return {
      email: { value: "", error: "" },
      pageStatus: "initial"
    };
  },

  computed: {
    isFormValid() {
      return !!this.email.value;
    },
    iconResetPassword() {
      return IconPasswordReset;
    }
  },

  created() {
    this.email.value = this.$store.state.form.authentication.email.value || "";
    this.email.error = this.$store.state.form.authentication.email.error || "";
  },

  methods: {
    async submitPwdRequest() {
      if (!this.isFormValid) {
        return;
      }

      try {
        this.pageStatus = "loading";
        await api.user.pwdChngRequest({ email: this.email.value });
        this.pageStatus = "loaded";
      } catch (err) {
        this.pageStatus = "error";
      }
    },

    goToLoginPage() {
      this.$router.push({ name: AUTHENTICATION.LOGIN.NAME });
    }
  }
});
